import React from "react";
import { useNavigate } from "react-router-dom";
import { HelpCircle } from "lucide-react";
import { useLang } from "@/i18n";
import useContent from "@/hooks/useContent";
import { Button } from "@/components/ui/button";
import { DarkPage, Reveal, SectionKicker, FaqList, FinalCta } from "@/components/marketing";

export default function FAQ() {
  const { t } = useLang();
  const nav = useNavigate();
  const content = useContent();
  return (
    <DarkPage>
      <section className="max-w-3xl mx-auto px-6 lg:px-8 pt-20 pb-16">
        <Reveal className="text-center mb-10">
          <SectionKicker><HelpCircle size={13} className="inline" /> FAQ</SectionKicker>
          <h1 className="font-head font-black text-4xl sm:text-5xl tracking-tight mb-3">{t("faq2_title")}</h1>
          <p className="text-zinc-400 text-lg">{t("faq2_sub")}</p>
        </Reveal>
        <FaqList items={content?.faq || []} testid="faq-full" />
        <div className="text-center mt-10">
          <Button onClick={() => nav("/auth?mode=signup")} data-testid="faq-cta" className="rounded-full bt-gradient text-white hover:opacity-90 font-bold px-8 min-h-[56px]">{t("cta_main")}</Button>
        </div>
      </section>
      <FinalCta content={content} />
    </DarkPage>
  );
}
